/*
  Youtube Player with Playlist (v2.22)
  https://github.com/carloscabo/responsive-youtube-player-with-playlist
  by Carlos Cabo (@putuko)
*/
var vt_vid_variable = '';
var vt_isSet = false;

var RYPP = (function ($, undefined) {
    'use strict';

    function Rypp(el, api_key, options) {

        if (typeof api_key === 'undefined') {
            //console.log("Youtube API V3 requires a valid API KEY.\nFollow the instructions at: https://developers.google.com/youtube/v3/getting-started");
            return false;
        }

        // DOM Elements container
        this.DOM = {};

        // Default settings container
        this.options = {};

        // Data / urls
        this.data = {
            // Playlist url
            ytapi: {
                playlist: 'https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=50&playlistId={{RESOURCES_ID}}&key={{YOUR_API_KEY}}',
                videolist: 'https://www.googleapis.com/youtube/v3/videos?part=snippet,status&maxResults=50&id={{RESOURCES_ID}}&key={{YOUR_API_KEY}}'
            },
            firsttime: true
        };

        // Initialize
        this.init(el, api_key, options);
    }

    // Prototype for the instance
    Rypp.prototype = {

        init: function (el, api_key, options) {

            // Api key
            this.api_key = api_key;

            // Default options
            this.options = {
                autoplay: true,
                autonext: false,
                showinfo: true,
                loop: true,
                mute: false
            }

            // Merge initial options
            if (typeof options !== 'undefined') {
                $.extend(this.options, options);
            }

            // YT Player object
            this.ytplayer = null;

            // DOM elements
            this.DOM = {};
            this.DOM.$el = $(el);
            this.DOM.$playlc = this.DOM.$el.find('.RYPP-playlist');
            this.DOM.$items = this.DOM.$el.find('.RYPP-items');
            this.DOM.$videoc = this.DOM.$el.find('.RYPP-video');
            this.DOM.$viddes = this.DOM.$el.find('.RYPP-description');
            // Unique player ID
            this.data.player_uid = (Math.random().toString(16).substr(2, 8));
            this.DOM.$el.attr('data-rypp', this.data.player_uid).find('.RYPP-video-player').attr('id', 'RYPP-vp-' + this.data.player_uid);


            // Link JS only once
            if (typeof YT === 'undefined') {
                var
                    tag = document.createElement('script'),
                    hID = document.getElementsByTagName('head')[0];
                // Add youtube API in HEAD
                // tag.src = "https://www.youtube.com/iframe_api";
                tag.src = 'https://www.youtube.com/player_api';
                hID.appendChild(tag);
            }

        },

        onYouTubeIframeAPIReady: function () {
            this.populatePlaylist();
        },

        populatePlaylist: function () {
            // Empty playlist
            this.DOM.$items.html('').append($('<ol>'));

            // Now we read the video list from playlist data or from IDs...
            if (this.DOM.$el.attr('data-playlist')) {
                this.getVideosFrom(
                    'playlist',
                    this.DOM.$el.attr('data-playlist')
                );
            }

            else if (this.DOM.$el.attr('data-ids')) {
                var vl = this.DOM.$el.attr('data-ids');
                // Clean spaces
                vl = ($.map(vl.split(','), $.trim)).join(',');
                this.getVideosFrom(
                    'videolist',
                    vl
                );

            }
        },

        addAPIPlayer: function () {
            var that = this;
            vt_vid_variable = that;

            this.ytplayer = new YT.Player('RYPP-vp-' + this.data.player_uid, {
                // height: '390',
                // width: '640',
                playerVars: {
                    // controls: 0,
                    showinfo: 1,
                    // autoplay: 0,
                    enablejsapi: 1,
                    rel: 0,
                    modestbranding: 1,
                    wmode: 'transparent'
                },
                events: {
                    'onReady': function () {
                        that.onPlayerReady();
                    },
                    'onStateChange': function (e) {

                        that.onPlayerStateChange(e);
                        var vt_action = '';
                        var vt_label = '';
                        var vt_category = 'Video';
                        if (e.data == YT.PlayerState.PLAYING) {
                            vt_action = 'Played';
                            vt_label = that.ytplayer.getVideoData().title + ' - PLAYED';
                        }
                        if (e.data == YT.PlayerState.PAUSED) {
                            vt_action = 'Paused';
                            vt_label = that.ytplayer.getVideoData().title + ' - PAUSED';
                        }
                        if (e.data == YT.PlayerState.ENDED) {
                            vt_action = 'Completed';
                            vt_label = that.ytplayer.getVideoData().title + ' - COMPLETED';
                        }

                        if (vt_action != '' && vt_label != '') {
                            dataLayer.push({ 'eventAction': vt_action });
                            dataLayer.push({ 'eventCategory': vt_category });
                            dataLayer.push({ 'eventLabel': vt_label });
                            dataLayer.push({ 'event': 'videotrack' });

                            console.log('fire event videotrack, action= ' + vt_action + ', CATEGORY= ' + vt_category + ', label= ' + vt_label + '.');
                        }
                    },
                    'onError': function (e) {
                        console.log(e);
                    }
                }

            });
        },


        // Ready to play
        onPlayerReady: function () {
            this.startPlayList();
            var that = this;

            var vt_playerid = this.data.player_uid;

            //Manual Click
            $('#thumbnail-hijack').on('click', function (ev) {

                if ($("#thumbnail-hijack").is(':visible')) {
                    hidestuff('thumbnail-hijack');
                }

                //replace video src url
                //var a = $('#RYPP-vp-' + vt_playerid)[0].src;

                //var b = vt_vid_variable.ytplayer.F.videoData.video_id;

                //var vt_url_A = a.substring(0, 30);

                //var position = a.indexOf("?");

                //var vt_url_B = a.substring(position, a.Length);

                //var output = vt_url_A + b + vt_url_B + '&autoplay=1';

                //$('#RYPP-vp-' + vt_playerid)[0].src = output;

                ev.preventDefault();
                that.ytplayer.playVideo([vt_playerid]);
            });

            if ($('RYPP-items').length) {
                $('RYPP-items').on('click', function (ev) {
                    showstuff('thumbnail-hijack');
                });
            }

        },


        // When video finish
        onPlayerStateChange: function (e) {

            if (typeof e !== 'undefined') {

                // On video loaded?
                if (e.data === -1 && this.data.firsttime) {
                    if (!this.options.autoplay) {
                        this.ytplayer.pauseVideo();
                    }
                    if (this.options.mute) {
                        this.ytplayer.mute();
                    }
                }

                // Play next
                var next = null;
                if (e.data === 0 && this.options.autonext) {
                    next = this.DOM.$items.find('li.selected').next();
                    if (next.length === 0 && this.options.loop) {
                        next = this.DOM.$items.find('li').first();
                    }
                    next.click();
                }

                // First video
                this.data.firsttime = false;

            }

        },

        // Get video from data-ids or playlist
        // It's impossible to know if a video in a playlist its available or currently deleted. So we do 2 request, first we get all the video IDs an then we ask for info about them.
        getVideosFrom: function (kind, resources_id) {

            var
                that = this,
                url = this.data.ytapi[kind].replace('{{RESOURCES_ID}}', resources_id).replace('{{YOUR_API_KEY}}', this.api_key);
            $.ajaxSetup({ cache: false });
            $.ajax(url, {
                context: this,
                dataType: 'json',
                crossDomain: true,
                error: function () {
                    // Not successful
                },
                success: function (data) {

                    // We queried for a playlist
                    if (data.kind === 'youtube#playlistItemListResponse') {

                        // We get the video IDs and query gain, its the only way to be sure that all the videos are available, and not were deleted :(
                        var vl = $.map(data.items, function (val, idx) {
                            if (typeof val.snippet.resourceId.videoId !== 'undefined') {
                                return val.snippet.resourceId.videoId;
                            }
                        }).join(',');

                        that.getVideosFrom('videolist', vl);

                    } else if (data.kind === 'youtube#videoListResponse') {

                        // Videos froma  Videolist
                        for (var i = 0, len = data.items.length; i < len; i++) {
                            var item = data.items[i];

                            // Videos without thumbnail, deleted or rejected are not included in the player!
                            if (
                                $.inArray(item.status.uploadStatus, ['rejected', 'deleted', 'failed']) === -1 &&
                                typeof item.snippet.thumbnails !== 'undefined'
                            ) {

                                var
                                    desc = item.snippet.description,
                                    vid = item.id,
                                    tit = item.snippet.title,
                                    aut = item.snippet.channelTitle,
                                    thu = item.snippet.thumbnails.high.url;
                                that.addVideo2Playlist(vid, tit, aut, thu, desc);
                            }
                        }
                        that.addAPIPlayer();
                    }
                }
            });
        },

        // All videos are supossed to be loaded
        // lets start the playlist
        startPlayList: function () {

            var
                D = this.DOM,
                vid = null,
                that = this;

            // Click on playlist elemnts
            D.$items.on('click', 'li', function (e) {
                e.preventDefault();
                D.$items.find('li').removeClass('selected');
                var descriptA = $(this).find('p.description').text();

                $(this).addClass('selected');
                vid = $(this).data('video-id');
                var activeVideoID = vid;
                // Call YT API function
                that.ytplayer.cueVideoById(vid);

                D.$viddes.text(descriptA);


                //replace thumbnail with high res image
                var vt_img = 'https://i1.ytimg.com/vi/' + vid;

                $('#thumbnail-hijack').css('background-image', 'url(' + vt_img + '/hqdefault.jpg)');

                if (!$("#thumbnail-hijack").is(':visible')) {
                    showstuff('thumbnail-hijack');
                    $('#thumbnail-hijack').css('display', 'block !important');

                }

            });
            // Select first if none
            if (D.$items.find('li.selected').length === 0) {
                D.$items.find('li').first().click();
            }


        },

        // Add video block to playlist
        addVideo2Playlist: function (vid, tit, aut, thu, desc) {
            var D = this.DOM;
            $('<li data-video-id="' + vid + '"><p class="title">' + tit + '<!--small class="author"><br>' + aut + '</small--></p><img src="' + thu + '" class="thumb"><p class="description" style="display: none;">' + desc + '</p></li>').appendTo(D.$items.find('ol'));
        },
    };
    // prototypes

    return Rypp;

}(jQuery));

// YOUTUBE API CALLBACK
function onYouTubeIframeAPIReady() {
  $('[data-rypp]').each(function (idx, el) {
      $(el)[0].rypp_data_obj.onYouTubeIframeAPIReady();
  });
}

// JQuery hook
$.fn.rypp = function (api_key, options) {
  return this.each(function () {
      // Store object in DOM element
      this.rypp_data_obj = new RYPP(this, api_key, options);
  });

};



// WEBPACK FOOTER //
// ./src/js/rypp/js/RYPP.js